// extracted by mini-css-extract-plugin
export default {"box":"file-mp4_box__z4Uy-","download":"file-mp4_download__zqaeM","preview":"file-mp4_preview__D9+jj","previewIcon":"file-mp4_previewIcon__uLWlP"};